/**
 * Function to get the full static asset path.
 *
 * @param relativePath - The relative path of the asset.
 * @returns The full static asset path.
 */

const FILESTACK_CONTENT_URL = "https://cdn.filestackcontent.com/";

const getStaticAssetPath = (relativePath: string): string => {
  if (relativePath.startsWith(FILESTACK_CONTENT_URL)) {
    return relativePath;
  }
  return `${process.env.REACT_APP_STATIC_ASSETS_PATH}/${relativePath}`;
};

/**
 * Function to remove the static asset path.
 *
 * @param relativePath - The relative path of the asset.
 * @returns The path without the static asset prefix.
 */
const removeStaticAssetPath = (relativePath: string): string => {
  // Check if the path starts with the Filestack content URL
  if (relativePath.startsWith(FILESTACK_CONTENT_URL)) {
    return relativePath;
  }
  // Remove the static asset path prefix from the relative path
  return relativePath.replace(
    process.env.REACT_APP_STATIC_ASSETS_PATH + "/",
    ""
  );
};

export { getStaticAssetPath, removeStaticAssetPath };
